<template>
    <section class="list-items-section">
        <div class="fe-btn-translation" @click="$root.$emit('open_modal_translation', 'Not Found', arrayTranslations)" v-if="globalTranslate">OPEN TRANSLATION</div>

        <div class="group_items">
            <div class="space-left"></div>
            <div class="empty-row full">
                <div class="icon">
                    <img src="/build/icons/not-found.svg">
                </div>
                <div class="title">
                    {{$t('not-found.title')}}
                </div>
                <div class="description narrow">
                    {{$t('not-found.description')}}
                </div>
                <div class="add-button">
                    <router-link class="button-tbf-blue" :to="{name: 'dashboard' }">{{$t('not-found.button')}}</router-link>
                </div>
            </div>
            <div class="space-right"></div>
        </div>
    </section>
</template>


<script>

    export default {
        data(){
            return{
                arrayTranslations: [
                    'not-found.title',
                    'not-found.description',
                    'not-found.button'
                ]
            }
        },
        mounted(){
            var title = '404';
            var backRoute = 'dashboard' 
            this.$root.$emit("navbar_title", title, backRoute)
        },
        methods: {
        }
    }
</script>
